var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8592 10.2645L11.4295 10.6909C11.4295 10.6909 10.4066 11.7036 7.61581 8.93841C4.825 6.17321 5.84783 5.16049 5.84783 5.16049L6.11793 4.89131C6.78565 4.2306 6.84893 3.16895 6.26621 2.39341L5.07622 0.809399C4.35467 -0.150609 2.96162 -0.277669 2.13524 0.541162L0.652471 2.00941C0.243529 2.416 -0.030358 2.94118 0.00269731 3.52471C0.0876968 5.01837 0.765803 8.23064 4.54733 11.9784C8.55836 15.9521 12.3219 16.1102 13.8604 15.9672C14.3478 15.922 14.7709 15.6754 15.1118 15.3366L16.4529 14.0076C17.3596 13.1107 17.1046 11.5718 15.9448 10.9441L14.1409 9.96618C13.3797 9.55488 12.4542 9.67535 11.8592 10.2645Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector7);
export default __webpack_public_path__ + "static/media/Vector (7).97d68597483ceaacafa1f77cf9c263a7.svg";
export { ForwardRef as ReactComponent };